import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    chargeRule : [],
    loading : false,
    error : null,
};

const chargeRuleSlice = createSlice({
    name:"chargeRule",
    initialState,
    reducers: {
        fetchChargeRuleSuccess: (state,action) => {
            state.loading = false;
            state.chargeRule = action.payload;
        },
        fetchChargeRuleFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchChargeRuleSuccess,
    fetchChargeRuleFailure
} = chargeRuleSlice.actions

export default chargeRuleSlice.reducer